export default __webpack_public_path__ + "static/media/Guru-Parampara-28.28d7cb0b.png";